

import React, { useContext } from "react"
import { useHistory, useParams } from "react-router-dom";
import { Grid } from "@material-ui/core"
import { QuoteContextStore } from '../../context/QuoteContext/QuoteContext';
import PilotItem from "./PilotItem";
import { OrangeButton } from "../Core/Buttons/OrangeButton";
import { FlowBackButton } from "../Core/Buttons/FlowBackButton";
import AddPilotButton from "./PilotSections/AddPilotButton";
import './Pilot.scss'
import { SessionContextStore } from "../../context/SessionContext/SessionContext";

export const PilotList = () => {
    const { quoteId } = useParams();
    const { pilots, finishPilots, resetCurrentPilot,locked_quote } = useContext(QuoteContextStore);

    const handleSaveAndContinue = async () => {
        await finishPilots({pilots, quote_id: quoteId}, false,locked_quote);
    }
    
    return (
        <Grid container item justifyContent="space-between" lg={9} className="margin-top-medium margin-bottom-basic">
            <Grid container className="margin-top-10 margin-bottom-10" spacing={2}>
                {pilots && Object.keys(pilots).map( id => <Grid key={id} item xs={12}>
                    <PilotItem pilot={pilots[id]} pilotId={id} />
                </Grid>)}
                <Grid item>
                    <AddPilotButton onClick={() => resetCurrentPilot(quoteId)}>Add Another Pilot</AddPilotButton>
                </Grid>
                <Grid item xs={12} className="margin-top-basic">
                    <FlowBackButton />
                    <OrangeButton onClick={handleSaveAndContinue}>Save & Continue</OrangeButton>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default PilotList;